/* src/app/privacy-policy/privacy-policy.component.css */
div.content .privacy_policy {
  background-color: rgba(255, 255, 255, 0.85);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr="#d9f5f5f5", endColorstr="#d9f5f5f5");
}
img.pnc_logo {
  width: 150px;
}
a {
  font-size: 16px;
}
/*# sourceMappingURL=privacy-policy.component.css.map */
